import React from 'react';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Icon } from 'antd';
import { ReactComponent as LockIcon } from './assets/lockIcon.svg';
import { setShowNotification } from '../../scenes/Admin/scenes/User/UserActions';

import './TwoFactorBanner.scss';

const TwoFactorBanner = () => {
  const dispatch = useDispatch();

  const closeBanner = () => dispatch(setShowNotification(false));

  return (
    <div className="two-factor-banner">
      <div className="close-icon-container">
        <Icon type="close" className="close-icon" onClick={closeBanner} />
      </div>
      <div className="arrow-top" />
      <div className="heading">
        <h3>Two-Factor Authentication Is On</h3>
        <Icon component={LockIcon} className="lock-icon" />
      </div>
      <Link to="/admin/settings" onClick={closeBanner}>
        <div className="contents">
          You can update your two-factor authentication to another method in{' '}
          <span className="underline">Admin &gt; Settings</span>.
        </div>
      </Link>
    </div>
  );
};

export default TwoFactorBanner;
